const PostSingle = {
    getBackgroundImageURL: (featuredImage) => {
        if (featuredImage && featuredImage.node)
            return featuredImage.node.localFile.childImageSharp.gatsbyImageData;
        
        return null;
    }
}

export default PostSingle;